module.exports = __webpack_public_path__ + "static/mh-example-2-99f80bbc76591d8d719db95c41ee2c82.jpg";